export default "__VITE_ASSET__mZ07X$8z__"